import { Redirect, useLocation } from 'react-router';
import { MastheadPortalId } from '../../../../models/AdminModels';
import { NavigationBreadcrumbsBar } from '../../../../web/components/NavigationBreadcrumbsBar';
import { Portal } from '../../../../web/components/Portal';
import { ICreateAccountRequest } from '../../../models/Accounts';
import { CreateAccountV2Step1 } from '../CreateAccountV2Step1';
import { CreateAccountV2Step2 } from '../CreateAccountV2Step2';

export function CreateAccountV2() {
	return (
		<div>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar currentLocationName='Create Account V2' />
			</Portal>
			<section>
				<CreateAccountV2Step1 />
			</section>
		</div>
	);
}

export function CreateAccountChargifyV2() {
	const { state: createAccountRequest } = useLocation<ICreateAccountRequest>();

	const pathComponentNameProvider = (companyName?: string) => (pathComponent: string) => {
		if (pathComponent === createAccountRequest?.account.id) {
			return companyName || 'Loading company...';
		}
		return pathComponent
			? `${pathComponent.charAt(0).toLocaleUpperCase()}${pathComponent.substring(1)}`
			: pathComponent;
	};

	if (!createAccountRequest?.account) {
		return <Redirect to='/accounts' />;
	}

	return (
		<div>
			<Portal destination={MastheadPortalId}>
				<NavigationBreadcrumbsBar
					currentLocationName='Create Account V2 - Chargify'
					pathComponentNameProvider={pathComponentNameProvider(createAccountRequest.account.companyName)}
				/>
			</Portal>
			<section>
				<CreateAccountV2Step2 createAccountRequest={createAccountRequest} />
			</section>
		</div>
	);
}
